module.exports = __webpack_public_path__ + "static/media/icon_download2.e5e98b1a.svg";